import React from 'react'
import CommonPage from './CommonPage';

export default function FavouritePage() {
  return (
    <>
    <CommonPage name={'favouriteQuestions'} />
    </>
  )
}
